import { render, staticRenderFns } from "./ImageQuizz.vue?vue&type=template&id=89e83ab4&"
import script from "./ImageQuizz.vue?vue&type=script&lang=js&"
export * from "./ImageQuizz.vue?vue&type=script&lang=js&"
import style0 from "./ImageQuizz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports